import React, { useEffect, useRef, useState } from "react";
import TimePicker from "react-time-picker";

const AdBreaksTable = ({
    appTheme,
    categoryTab,
    handlecategoryTab,
    locationState,
    assetInfo,
    selectedFillers,
    fillerList,
    millisecondsToHuman,
    updateAdsTime,
    deleteAdEvent,
    deleteIcon,
    adAdsOnClick,
    viewType,
    promoList,
    setShouldSort
}) => {
    const blurTimeouts = useRef({});
    const latestTimeValues = useRef({});
    const tbodyRef = useRef(null);
    const assetInfoRef = useRef(assetInfo);
    useEffect(() => {
        assetInfoRef.current = assetInfo;
    }, [assetInfo]);

    // useEffect(() => {
    //     const handleFocusOut = () => {
    //         // setTimeout(() => {
    //             console.log('tbodyRef',tbodyRef);
    //             console.log('tbodyRef.current.contains(document.activeElement)',tbodyRef.current.contains(document.activeElement));
    //             if (tbodyRef.current && !tbodyRef.current.contains(document.activeElement)) {
    //                 const sequence = assetInfoRef.current?.sequence;
    //                 if (sequence !== undefined) {
    //                     setShouldSort(sequence); // ✅ uses the latest sequence
    //                 }
    //             }
    //         // }, 300);
    //     };

    //     const tbodyEl = tbodyRef.current;
    //     if (tbodyEl) {
    //         tbodyEl.addEventListener('focusout', handleFocusOut);
    //     }

    //     return () => {
    //         if (tbodyEl) {
    //             tbodyEl.removeEventListener('focusout', handleFocusOut);
    //         }
    //     };
    // }, []);

    useEffect(() => {
    const handleClick = (e) => {
        if (tbodyRef.current) {
            if (!(tbodyRef.current.contains(e.target))) {
                const sequence = assetInfoRef.current?.sequence;
                if (sequence !== undefined) {
                    setShouldSort(sequence);
                }
            }
        }
    };

    document.addEventListener("mousedown", handleClick);

    return () => {
        document.removeEventListener("mousedown", handleClick);
    };
    }, []);



    const handleChange = (val, adSqId) => {
        latestTimeValues.current[adSqId] = val;
    };

    const handleBlur = (adSqId, sequence) => {
        // Clear existing timeout (if any)
        if (blurTimeouts.current[adSqId]) {
        clearTimeout(blurTimeouts.current[adSqId]);
        }

        // Set new timeout
        blurTimeouts.current[adSqId] = setTimeout(() => {
        const latestValue = latestTimeValues.current[adSqId];
        if (latestValue) {
            updateAdsTime(latestValue, adSqId, sequence);
            latestTimeValues.current[adSqId] = null;
        }
        }, 100); // Short delay
    };

    const handleFocus = (adSqId) => {
        if (blurTimeouts.current[adSqId]) {
        clearTimeout(blurTimeouts.current[adSqId]);
        }
    };
  return (
    <div className={`bottom-content-right ${appTheme === "light"? "rounded shadow-sm": ""}`} style={{ height: viewType === "expandView" ? "495px" : "535px" }}>
        <div className="tabs mt-4 p-2">
            <ul className={`channel-category-tab px-1 ${appTheme === "light" ? "border shadow-sm": ""}`}>
                <li className={categoryTab === "Ads" ? "active" : ""}>
                <a className="p-0" style={{height: "1.5rem"}} onClick={() => handlecategoryTab("Ads")}>Ads <span>{assetInfo?.adBreaks?.filter(item => viewType === "expandView" ? item.type === "filler" : item.assetType === "FILLER" || item.assetType === "AD")?.length || 0}</span></a>
                </li>
                <li className={categoryTab === "Promos" ? "active" : ""}>
                <a className="p-0" style={{height: "1.5rem"}} onClick={() => handlecategoryTab("Promos")}>Promos <span>{assetInfo?.adBreaks?.filter(item => viewType === "expandView" ? item.type === "promo" : item.assetType === "PROMO")?.length || 0}</span></a>
                </li>
                <li className={categoryTab === "Secondary" ? "active" : ""}>
                <a className="p-0" style={{height: "1.5rem"}} disable onClick={() => {handlecategoryTab("Secondary");}}>Secondary</a>
                </li>
            </ul>
        </div>
        <div className={`ads-table mx-2 my-3 p-2 rounded ${appTheme === "light"? "shadow-sm border" : ""}`}>
            <table className={`table ${appTheme === "light"? "border table-striped table-hover" : ""}`}>
                <thead>
                    <tr>
                        <th>Name <span className="header-icon"></span></th>
                        <th role="button">Start Time</th>
                        <th>Duration</th>
                        <th>
                            {
                                locationState?.state?.permission === "edit" &&
                                "Actions"
                            }
                        </th>
                    </tr>
                </thead>
                <tbody ref={tbodyRef} tabIndex={-1}>
                { categoryTab === "Ads"?
                    assetInfo?.adBreaks?.some((data) => data?.assetType === "AD" || data?.assetType === "FILLER" || data?.type === "filler" || data?.type === "ad")?
                        assetInfo?.adBreaks
                        ?.filter((data) => data?.assetType === "AD" || data?.assetType === "FILLER" || data?.type === "filler" || data?.type === "ad")
                        .map((data, index) => {
                            return (
                                <tr key={data.id}>
                                    <td style={{width:"40%"}}>   
                                        <select className="p-0" value={data?.assetId} onChange={(e)=> {selectedFillers(e.target.value, data?.adSqId, assetInfo?.sequence, "FILLER")}}>
                                            {
                                                fillerList?.map((fillers) => {
                                                    return <option value={fillers?.id} >{fillers?.filename}</option>
                                                })
                                            }
                                        </select>
                                    </td>
                                    <td style={{width:"25%"}}>
                                        <TimePicker
                                            value={millisecondsToHuman(data?.adInsertionPoint)}
                                            hourPlaceholder="HH"
                                            minutePlaceholder="mm"
                                            secondPlaceholder="ss"
                                            maxDetail="second"
                                            // maxTime={parentData?.extendedProps.endAt}
                                            // minTime={parentData?.extendedProps.startAt}
                                            format="HH:mm:ss"
                                            disableClock={true}
                                            onChange={(e) => {
                                                updateAdsTime(e, data?.adSqId, assetInfo?.sequence);
                                            }}
                                        />
                                        {/* <TimePicker
                                            key={data.adSqId}
                                            value={millisecondsToHuman(data?.adInsertionPoint)}
                                            hourPlaceholder="HH"
                                            minutePlaceholder="mm"
                                            secondPlaceholder="ss"
                                            maxDetail="second"
                                            format="HH:mm:ss"
                                            disableClock={true}
                                            onChange={(val) => handleChange(val, data.adSqId)}
                                            onFocus={() => handleFocus(data.adSqId)}
                                            onBlur={() => handleBlur(data.adSqId, assetInfo?.sequence)}
                                        /> */}
                                    </td>
                                    <td style={{width:"25%"}}>
                                        <div className="ads-duration">
                                            {millisecondsToHuman( viewType === "expandView" ? data?.duration : data?.durationInMillis)}
                                        </div>
                                    </td>
                                    {/* <td>
                                        <TimePicker
                                            value={millisecondsToHuman(data?.durationInMillis)}
                                            hourPlaceholder="HH"
                                            minutePlaceholder="mm"
                                            secondPlaceholder="ss"
                                            maxDetail="second"
                                            // maxTime={parentData?.extendedProps.endAt}
                                            // minTime={parentData?.extendedProps.startAt}
                                            format="HH:mm:ss"
                                            disableClock={true}
                                            onChange={(e) => {
                                                setDurationTime(e, data?.adSqId, assetInfo?.sequence);
                                            }}
                                        />
                                    </td> */}
                                    <td className="text-center align-middle" style={{width:"10%"}}>
                                        {
                                            locationState?.state?.permission === "edit" &&
                                            <div className="table-action-group p-0 w-75 mx-auto">
                                                <div className='icon-group pe-auto' onClick={()=> {deleteAdEvent(data?.adSqId, assetInfo?.sequence)}}>
                                                    {/* <span className="table-icon me-1"><img src={editIcon} /></span> */}
                                                    <span className="table-icon"><img src={deleteIcon} width={15} /></span>
                                                </div>
                                            </div>
                                        }
                                    </td>
                                </tr>
                            );
                        })
                        :
                        <td colspan="4" class="text-center no-data" style={{height: "210px"}}>
                            No ads to display.
                        </td>
                    :
                    categoryTab === "Promos"?
                    assetInfo?.adBreaks?.some((data) => data?.assetType === "PROMO" || data?.type === "promo")?
                        assetInfo?.adBreaks
                        ?.filter((data) => data?.assetType === "PROMO" || data?.type === "promo")
                        .map((data) => {
                            return (
                                <tr key={data.id}>
                                    <td style={{width:"40%"}}>
                                        <select className="p-0" value={data?.assetId} onChange={(e)=> {selectedFillers(e.target.value, data?.adSqId, assetInfo?.sequence, "PROMO")}}>
                                            {
                                                promoList?.map((promo) => {
                                                    return <option value={promo?.id} >{promo?.filename}</option>
                                                })
                                            }
                                        </select>
                                    </td>
                                    <td style={{width:"25%"}}>
                                        <TimePicker
                                            value={millisecondsToHuman(data?.adInsertionPoint)}
                                            hourPlaceholder="HH"
                                            minutePlaceholder="mm"
                                            secondPlaceholder="ss"
                                            maxDetail="second"
                                            // maxTime={parentData?.extendedProps.endAt}
                                            // minTime={parentData?.extendedProps.startAt}
                                            format="HH:mm:ss"
                                            disableClock={true}
                                            onChange={(e) => {
                                                updateAdsTime(e, data?.adSqId, assetInfo?.sequence);
                                            }}
                                            // onChange={(val) => handleChange(val, data.adSqId)}
                                            // onFocus={() => handleFocus(data.adSqId)}
                                            // onBlur={() => handleBlur(data.adSqId, assetInfo?.sequence)}
                                        />
                                    </td>
                                    <td style={{width:"25%"}}>
                                        <div className="ads-duration">
                                            {millisecondsToHuman( viewType === "expandView" ? data?.duration : data?.durationInMillis)}
                                        </div>
                                    </td>
                                    <td className="text-center align-middle" style={{width:"10%"}}>
                                        {
                                            locationState?.state?.permission === "edit" &&
                                            <div className="table-action-group p-0 w-75 mx-auto">
                                                <div className='icon-group pe-auto'>
                                                    {/* <span className="table-icon me-1"><img src={editIcon} /></span> */}
                                                    <span className="table-icon" onClick={()=> {deleteAdEvent(data?.adSqId, assetInfo?.sequence)}}><img src={deleteIcon} /></span>
                                                </div>
                                            </div>
                                        }
                                    </td>
                                </tr>
                            );
                        })
                        :
                        <td colspan="4" class="text-center no-data" style={{height: "210px"}}>
                            No promos to display.
                        </td>
                    :
                    categoryTab === "Secondary"?
                    <td colspan="4" class="text-center no-data" style={{height: "210px"}}>
                        No Secondary to display.
                    </td>
                    :
                    ''
                }
                </tbody>
            </table>
        </div>
        {/* {
            categoryTab === "Ads"?
            <span className="mt-3 ads-table-btn p-2 text-decoration-underline" onClick={() => {
                adAdsOnClick(assetInfo?.sequence);
            }}>+ Ad Break</span>
            :
            ''
        } */}
        {(() => {
            const map = {
                Ads: { label: "Ad", type: "AD" },
                Promos: { label: "Promo", type: "PROMO" },
            }[categoryTab];
            return map ? (
                <span
                    className="mt-3 ads-table-btn p-2 text-decoration-underline"
                    onClick={() => 
                        adAdsOnClick(assetInfo?.sequence, map.type)
                    }
                >
                    + {map.label} Break
                </span>
            ) : null;
        })()}
    </div>
  );
};

export default AdBreaksTable;
